import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class Handlers {
    private handlers: any [];

    getHandlers(){
        return this.handlers;
    }

    setHandlers(handlers){
        this.handlers = handlers;
    }

}
